import store from '../store'

/**
 * Show notification
 * @param {import("../store/modules/notifications").Notification} options
 */
export default function (options) {
  store.commit('notifications/add', options)
}
